import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import { ZoomService } from '../profile.service';
import { ZoomMeeting, ZoomMeetingForm } from '../model/model.class';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AppComponentClass } from '../../shared/service/AppComponent.class';

@Component({
  selector: 'app-zoommeeting',
  templateUrl: './zoommeeting.component.html',
  styleUrls: ['./zoommeeting.component.css']
})
export class ZoommeetingComponent extends AppComponentClass<ZoomMeeting, ZoomMeetingForm> {
  
  form : FormGroup;
  key:number;
  public iszoom:boolean=false;
    
  constructor(protected data: ZoomService, protected router: Router, protected fb: FormBuilder, protected msg: MatSnackBar) {
    super(data, router, fb , msg);   
  }


ngOnInit() {    
    this.data.getService().subscribe(res=>{
      if(res.length > 0)
      {
        console.log("Update data "+JSON.stringify(res));
        this.cdata=new ZoomMeetingForm(res[0]);
        this.keyfield=res[0].id;
        this.form=this.cdata.makeform(this.fb);
      }
      else
      {
        console.log("adding data "+JSON.stringify(res));
        this.cdata=new ZoomMeetingForm(null);
        this.keyfield=-1;
        this.form=this.cdata.makeform(this.fb);
      }
      this.iszoom=true;
    },
    err=>{
        this.cdata=new ZoomMeetingForm(null);
        this.keyfield=-1;
        this.form=this.cdata.makeform(this.fb);
        this.iszoom=true;
    });   
  
}

  onSubmit()
  {
    if(this.cdata.saveForm(this.form))
    {
      if(this.keyfield==-1)
        {
          this.data.saveService(JSON.stringify(this.cdata)).subscribe( rs =>  {           
            this.openSnackBar("Data is added successfully","Clear");   
            this.data.getService().subscribe(res=>{              
              this.cdata=new ZoomMeetingForm(res[0]);
              this.keyfield=res[0].id;
              this.form=this.cdata.makeform(this.fb);  
            });       
          });
        }
        else
        {
          this.data.updateService(JSON.stringify(this.cdata), this.keyfield).subscribe( rs => 
          {             
            this.openSnackBar("Data is updated successfully","Clear");
            this.data.getService().subscribe(res=>{              
              this.cdata=new ZoomMeetingForm(res[0]);
              this.keyfield=res[0].id;
              this.form=this.cdata.makeform(this.fb);  
            });     
          });
        }
    }  
  }

  AddZoomMeeting()
  {    
    this.data.SaveZoomURL(JSON.stringify({zoomurl:this.form.get("zoomurl").value})).subscribe(res =>{      
      this.openSnackBar("Zomm Meeting Url Save Successfully.", "Clear"); 
    });
  } 

}

